import { Map } from 'ol';
import { OSM } from 'ol/source';

import { WmsSource } from '.';

export class OpenStreetMapSource extends WmsSource {
  constructor() {
    super();

    this.source = new OSM({ transition: 0 });
  }

  async initialize() {
    // No initialization needed for OpenStreetMap.
  }

  async updateAttributions(olMap: Map): Promise<void> {
    // Attributions are handled internally by OpenStreetMap.
  }
}
